import React from "react";
import { Series } from "remotion";

import { Hero } from "./scenes/Hero";
import { Capabilities } from "./scenes/Capabilities";

/**
 * ProductLaunch — a two-scene product film.
 *
 * 1. Hero         150 frames  (5.0s)   product statement
 * 2. Capabilities 240 frames  (8.0s)   the three abilities
 *
 * Total: 390 frames @ 30fps = 13.0s
 */
export const ProductLaunch: React.FC = () => {
  return (
    <Series>
      <Series.Sequence durationInFrames={150}>
        <Hero />
      </Series.Sequence>

      <Series.Sequence durationInFrames={240}>
        <Capabilities />
      </Series.Sequence>
    </Series>
  );
};